// @flow
import type { ID } from '../../core/types'
import type { Item } from './types'
import { FETCH_ITEM_RESOURCE, FETCH_ITEM_BIDS_RESOURCE } from './constants'

export const isItemCompleted = (item: Item): boolean =>
  Boolean(
    item.title &&
      item.itemNumber &&
      item.category &&
      item.description &&
      item.initialBid &&
      Boolean(Array.isArray(item.media) && item.media.length > 0)
  )

export const createFetchItemResource = (id: ID): string =>
  FETCH_ITEM_RESOURCE + id

export const createFetchItemBidsResource = (itemId: number): string =>
  `${FETCH_ITEM_BIDS_RESOURCE}${itemId}`



// WEBPACK FOOTER //
// ./src/services/item/utils.js